import * as React from 'react';
import { BaseLayersListUL } from 'scenes/map/controls/base-map-switcher/layers-list';
import { useSelector } from 'react-redux';
import { getOmjsViewInstance, getOperationData } from 'selectors';
import { actions as mapActions } from 'services/map/map-service';
import { createSelector } from 'reselect';
import { IState } from 'services/root-reducer';

export const BaseLayersListULWrapper = () => {
    const view = useSelector(getOmjsViewInstance);
    const mapState = useSelector(
        createSelector(
            (state: IState) => getOperationData(state, 'MAP_STATE'),
            state => state
        )
    );
    const publicationSettings = useSelector(
        createSelector(
            (state: IState) => state.app.config.publication,
            publication => publication
        )
    );

    return (
        <BaseLayersListUL
            layersList={publicationSettings.base_maps}
            lng={view.getProject().lng as string}
            currentBaseMapId={mapState.baseMapId}
            cadastreIsVisible={mapState.cadastreVisible}
            showCadastreLayer={mapActions.showCadastreLayer}
            switchBaseMap={mapActions.switchBaseLayer}
        />
    );
};
